import React from 'react';
import Subcat from '../elements/subcat'
import axios from 'axios';
import ym from 'react-yandex-metrika';
import { CSSTransition } from 'react-transition-group';

import FilterBtn from '../buttons/FilterBtn';
import SubcatLevel2 from '../elements/subcatLevel2'

class CategoryRealEstate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            subcategories: [],
            sale: false,
            rent: false,
            parentCategories: false
        }
    }

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_SITE_URL}/api/categories?parents=41-real-estate&categoryId=41&lang=ru&pagetitle=&rand=0.7143301590562461`)
            .then(res => {
                this.setState({
                    parentCategories: res.data.items
                })
            })
    }

    getCategories = (categoryFilter, category, e) => {
        ym('reachGoal', 'nedvijimost');
        let oldcategory
        if (category == "sale") {
            oldcategory = "rent"
        }
        else {
            oldcategory = "sale"
        }
        this.props.changeObjectsEstate("41-real-estate", "41", "41", categoryFilter, e)
        this.props.changeActiveCat(category)
        axios.get(`${process.env.REACT_APP_SITE_URL}/api/categories?parents=41-real-estate&categoryId=41&lang=ru&pagetitle=&rand=0.7143301590562461`)
            .then(res => {
                this.setState({
                    subcategories: res.data.items,
                    [category]: true,
                    [oldcategory]: false
                })
            })
    }

    render() {
        const subcats = this.state.subcategories
        const panoUrl = this.props.panourl
        const parentCategories = this.state.parentCategories

        return (
            <div className="main-panel__cat-item real-estate">
                <a href={panoUrl ? panoUrl : '#'} onClick={(e) => this.getCategories("", "", e)} className="cat-icon">
                    <svg className="cat-icon__svg" version="1.1" xmlns="http://www.w3.org/2000/svg"
                        y="0px" viewBox="0 0 60 60"
                    >
                        <g>
                            <path
                                d="M30,59.8C13.5,59.8,0.2,46.5,0.2,30S13.5,0.3,30,0.3S59.8,13.6,59.8,30S46.4,59.8,30,59.8z M30,2.3											  C14.6,2.3,2.2,14.7,2.2,30c0,15.3,12.5,27.8,27.8,27.8S57.8,45.4,57.8,30C57.8,14.7,45.3,2.3,30,2.3z">
                            </path>
                        </g>
                        <g>
                            <path d="M30,58.8H1.2V30c0,0-0.4,11.7,8.3,20.3S30,58.8,30,58.8z"></path>
                            <path
                                d="M30,59.8H0.2V30.6c0-0.3,0-0.5,0-0.6l2,0v0.4c0,1.9,0.6,11.8,8,19.2c8.3,8.2,19.6,8.3,19.8,8.3V59.8z											   M2.2,57.8h17.6c-3.5-1.3-7.5-3.4-11-6.8c-3.3-3.3-5.4-6.9-6.6-10.3V57.8z">
                            </path>
                        </g>
                    </svg>
                    <div className="cat-icon__img">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                            y="0px" viewBox="0 0 60 60"
                        >
                            <g>
                                <path className="" d="M53.3,54.4H6.8c-0.6,0-1-0.4-1-1V27.4c0-0.3,0.1-0.6,0.4-0.8L28.9,7.4c0.4-0.4,1.1-0.3,1.4,0.1
		C30.7,8,30.6,8.6,30.2,9L7.8,27.9v24.6h44.6V25.3L29.5,2.6L2.7,25.1c-0.4,0.4-1.1,0.3-1.4-0.1c-0.4-0.4-0.3-1.1,0.1-1.4L28.9,0.4
		c0.4-0.3,1-0.3,1.4,0.1L54,24.2c0.2,0.2,0.3,0.4,0.3,0.7v28.5C54.3,54,53.9,54.4,53.3,54.4z" />
                            </g>
                        </svg>
                    </div>
                </a>

                <div className="main-panel__cat-title">
                    Недвижимость
                </div>
                <CSSTransition in={this.props.realEstate}
                    timeout={300}
                    classNames="subcat"
                    unmountOnExit
                >
                    <div className="main-panel__subcat">
                        <FilterBtn
                            changeScreen={this.props.changeScreen}
                        />
                        <SubcatLevel2
                            title="Продажа"
                            filter="687-sale"
                            category="sale"
                            activeCat={this.props.activeCat}
                            sale={this.state.sale}
                            onClick={this.getCategories}
                            panourl={parentCategories !== false ? parentCategories[0].pano_url : '#'}
                        />
                        <div className="main-panel__subcat main-panel__subcat_level2">
                            <CSSTransition in={this.state.sale}
                                classNames="subcat"
                                timeout={300}
                                unmountOnExit
                            >
                                <div className="main-panel__subcat">
                                    {Object.keys(subcats).map((subcat, i) => <Subcat
                                        goal={subcats[i].metrika}
                                        changeObjects={this.props.changeObjectsEstate}
                                        changeActiveCat={this.props.changeActiveCat}
                                        title={subcats[i].longtitle}
                                        idCategory={subcats[i].searchId}
                                        id={subcats[i].itemId}
                                        key={i}
                                        parent="41"
                                        activeCat={this.props.activeCat}
                                        categoryFilter={"687-sale"}
                                        pano_url={subcats[i].pano_url}
                                    />
                                    )}
                                </div>
                            </CSSTransition>
                        </div>
                        <SubcatLevel2
                            title="Аренда"
                            filter="688-rent"
                            category="rent"
                            activeCat={this.props.activeCat}
                            sale={this.state.sale}
                            onClick={this.getCategories}
                            panourl={parentCategories !== false ? parentCategories[1].pano_url : '#'}
                        />

                        <div className="main-panel__subcat main-panel__subcat_level2">
                            <CSSTransition in={this.state.rent}
                                classNames="subcat"
                                timeout={300}
                                unmountOnExit
                            >
                                <div className="main-panel__subcat">
                                    {Object.keys(subcats).map((subcat, i) => <Subcat
                                        goal={subcats[i].metrika}
                                        changeObjects={this.props.changeObjectsEstate}
                                        changeActiveCat={this.props.changeActiveCat}
                                        title={subcats[i].longtitle}
                                        idCategory={subcats[i].searchId}
                                        id={subcats[i].itemId}
                                        key={i}
                                        parent="41"
                                        activeCat={this.props.activeCat}
                                        categoryFilter={"688-rent"}
                                        pano_url={subcats[i].pano_url}
                                    />
                                    )}
                                </div>
                            </CSSTransition>
                        </div>
                    </div>
                </CSSTransition>
            </div >
        )
    }
}

export default CategoryRealEstate;